import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import UiFormControlLabel from 'ui-components/ui-form-control-label/UiFormControlLabel';
import UiCheckbox from 'ui-components/ui-checkbox/UiCheckbox';
import { getCurrentSlice } from 'utils';

/**
 * فیلتر انتخاب نوع جنسیت
 */
export const GenderFilter = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { componentName, parentPlatform, className } = props;
  const filter = useSelector((state) =>
    parentPlatform
      ? state[state.filterReducer.filtersContext].filters[parentPlatform][
          componentName
        ]
      : state[state.filterReducer.filtersContext].filters[componentName]
  );
  const reducerName = useSelector(
    (state) => state.filterReducer.filtersContext
  );
  const { selectedIds, isDisabled } = filter;
  const { setSelectedFilterIds } = getCurrentSlice(reducerName);

  const handleChangeGenderType = (event, id) => {
    dispatch(
      setSelectedFilterIds({
        id,
        isChecked: event.target.checked,
        componentName,
        parentPlatform,
      })
    );
  };

  const genderTypes = [
    {
      id: 'male',
      label: t('filter:man'),
      testId: 'filter-gender-male-checkbox',
      labelTestId: 'filter-gender-male-label',
    },
    {
      id: 'female',
      label: t('filter:woman'),
      testId: 'filter-gender-female-checkbox',
      labelTestId: 'filter-gender-female-label',
    },
    {
      id: 'org',
      label: t('filter:company'),
      testId: 'filter-gender-org-checkbox',
      labelTestId: 'filter-gender-org-label',
    },
  ];

  return (
    <div className={classNames('grid', className)}>
      {genderTypes.map(({ id, label, testId, labelTestId }) => (
        <UiFormControlLabel
          key={id}
          className='mr-0'
          label={label}
          data-testid={labelTestId}
          control={
            <UiCheckbox
              checked={selectedIds?.includes(id)}
              name='male'
              inputProps={{ 'data-testid': testId }}
              onChange={(event) => handleChangeGenderType(event, id)}
              disabled={isDisabled}
            />
          }
        />
      ))}
    </div>
  );
};

GenderFilter.propTypes = {
  componentName: PropTypes.string.isRequired,
  parentPlatform: PropTypes.string,
  className: PropTypes.string,
};
